<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="container">
      <div class="top">
        <div class="desc">
        </div>
      </div>
      <div v-if="showLogin">
        <route-view></route-view>
      </div>
    </div>
  </div>
</template>

<script>
import RouteView from './RouteView'
import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'UserLayout',
  components: { RouteView },
  mixins: [mixinDevice],
  data () {
    return {
      showLogin: document.body.clientWidth > 768
    }
  },
  mounted () {
    document.body.classList.add('userLayout')
  },
  beforeDestroy () {
    document.body.classList.remove('userLayout')
  }
}
</script>

<style lang="less" scoped>
  #userLayout.user-layout-wrapper {
    height: 100%;

    &.mobile {
      .container {
        .main {
          max-width: 368px;
          width: 98%;
        }
      }
    }

    .container {
      width: 100%;
      height: 100vh;
      /* 面板背后的一束冷光：毛玻璃需要有可扩散的光源，
         否则在一张平底图上只能读出“一块半透明的黑”。
         它必须画在容器的背景层上，不能做成绝对定位的伪元素：
         820px 的光晕按 top:-240 / right:-60 摆放时一定溢出容器，
         会把 body 撑出 60px 横向 + 78px 纵向的滚动条；背景层不参与滚动区域计算。
         光心位置和原来一致（left = 100% - 350px，top = -240 + 410），
         落在面板上边缘偏右的空黑区：光源必须有一半在玻璃外部，
         才能让那块模糊的边缘成为“玻璃”的证据 */
      background:
        radial-gradient(circle 580px at calc(100% - 350px) 170px,
          rgba(70, 196, 255, 0.42) 0%,
          rgba(24, 132, 210, 0.24) 34%,
          rgba(12, 62, 104, 0.10) 58%,
          rgba(10, 19, 28, 0) 74%),
        url(../assets/login-bg.webp) no-repeat;
      background-size: auto, 100% 100%;
      padding: 110px 0 144px;
      position: relative;
      /* 登录页是一整屏，不该有需要滚动才看得到的内容 */
      overflow: hidden;

      a {
        text-decoration: none;
      }

      .top {
        text-align: center;

        .header {
          height: 44px;
          line-height: 44px;

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            height: 44px;
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
            color:white;
          }

          .title {
            font-size: 33px;
            color: rgba(0, 0, 0, .85);
            font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
            font-weight: 600;
            position: relative;
            top: 2px;
          }
        }
        .desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }

      .main {
        min-width: 260px;
        width: 368px;
        margin: 0 auto;
      }

      .footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 48px 0 24px;
        text-align: center;

        .links {
          margin-bottom: 8px;
          font-size: 14px;
          a {
            color: rgba(0, 0, 0, 0.45);
            transition: all 0.3s;
            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }
        .copyright {
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
        }
      }
    }
  }
</style>
